import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import LeafIcon from "../../../../assets/Fibo/icons/LeafIcon";
import BriaInput from "../../../../components/common/BriaInput/BriaInput";
import { useSeedValidation } from "../../../../hooks/useSeedValidation";
import FiboPopoverButton from "../Popover/FiboPopoverButton";
import styles from "./FiboSeed.module.scss";

export interface IFiboSeedProps {
	onChange: (value: number | undefined) => void;
	value: number | undefined;
}

const FiboSeed = ({ onChange, value }: IFiboSeedProps) => {
	const { t } = useTranslation("fibo", { keyPrefix: "lab.settings.seed" });

	const { handleSeedChange } = useSeedValidation({
		onSeedChange: (seed) => onChange(seed),
	});

	return (
		<FiboPopoverButton icon={<LeafIcon />} tooltip={t("tooltip")} buttonText={String(value ?? t("placeholder"))}>
			<Box className={styles.seedContainer}>
				<Typography className={styles.seedLabel}>{t("label")}</Typography>
				<BriaInput
					type="number"
					value={value}
					onChange={handleSeedChange}
					placeholder={t("placeholder")}
					height="28px"
					className={styles.seedInput}
				/>
			</Box>
		</FiboPopoverButton>
	);
};

export default observer(FiboSeed);
